import {useEffect} from "react";

const useVideo = () => {
    useEffect(() => {
        const url = "https://www.youtube.com/iframe_api";
        fetch(url, {method: 'GET', mode: 'no-cors'})
            .then(response => {
                var tag = document.createElement("script");
                tag.src = url;
                const firstScriptTag = document.getElementsByTagName("script")[0];
                // @ts-ignore
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            })
            .catch(function (error) {
                //Handle error
                // console.log(error);
            });
    }, []);
}

export default useVideo;